import { render, staticRenderFns } from "./StorageSharing.vue?vue&type=template&id=7cf79322&"
import script from "./StorageSharing.vue?vue&type=script&lang=ts&"
export * from "./StorageSharing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports